import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ReportShell, Stat, Table } from "./ReportShell";

export const OutOfStockReport = () => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const generate = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/reports/out-of-stock");
      setData(data);
    } finally {
      setBusy(false);
    }
  };
  const t = data?.totals;
  const colors = data?.colors || [];
  const sinks = data?.sinks || [];

  return (
    <ReportShell
      id="out-of-stock"
      title="Out of Stock"
      blurb="Colors you carry with nothing left In Stock (reserved or consumed only) and sinks at zero. Open quotes still asking for a color float to the top so you know what to reorder first."
      onGenerate={generate}
      busy={busy}
      generated={!!data}
      csvRows={colors}
      csvName="out-of-stock.csv"
    >
      {t && (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          <Stat label="Colors out" value={t.colors} tone="text-red-400" testId="oos-stat-colors" />
          <Stat label="With open quotes" value={t.with_open_quotes} tone="text-amber-300" testId="oos-stat-quotes" />
          <Stat label="Sinks at zero" value={t.sinks} tone="text-blue-400" testId="oos-stat-sinks" />
        </div>
      )}
      <div className="mt-4">
        <Table
          testId="oos-colors"
          rowKey={(r) => r.slab_color}
          rows={colors}
          empty="Every color you carry has at least one slab in stock."
          columns={[
            {
              key: "slab_color",
              label: "Color",
              render: (r) => (
                <Link to={`/inventory/slabs?q=${encodeURIComponent(r.slab_color)}`} className="font-semibold text-yellow-400 hover:underline">
                  {r.slab_color}
                </Link>
              ),
            },
            { key: "supplier", label: "Supplier", render: (r) => <span className="text-zinc-400">{r.supplier || "—"}</span> },
            { key: "open_quotes", label: "Open quotes", right: true, render: (r) => <span className={r.open_quotes ? "font-bold text-amber-300" : "text-zinc-500"}>{r.open_quotes}</span> },
            { key: "reserved", label: "Reserved", right: true },
            { key: "consumed", label: "Consumed", right: true },
            { key: "remnant_sqft", label: "Remnant ft²", right: true, render: (r) => <span className="text-blue-400">{r.remnant_sqft}</span> },
          ]}
        />
      </div>
      <div className="mt-6">
        <div className="mb-2 text-xs uppercase tracking-widest text-zinc-500">Sinks at zero</div>
        <Table
          testId="oos-sinks"
          rowKey={(r) => r.id}
          rows={sinks}
          empty="No sinks at zero."
          columns={[
            { key: "model", label: "Sink", render: (r) => <span className="font-semibold">{[r.brand, r.model].filter(Boolean).join(" ")}</span> },
            { key: "sink_type", label: "Type" },
            { key: "supplier", label: "Supplier", render: (r) => <span className="text-zinc-400">{r.supplier || "—"}</span> },
            { key: "quantity", label: "Qty", right: true, render: (r) => <span className="text-red-400">{r.quantity}</span> },
          ]}
        />
      </div>
    </ReportShell>
  );
};
